import { createReducer, combineReducers } from '@reduxjs/toolkit'

import { login, logout, refreshSTK, setReady, setSTKExpired, setSTKToken, loadRequiredData } from './auth.actions'

const authStartPending = (state) => {
  state.status = 'loading'
}

const authActionFullfiled = (state) => ({
  ...initial, // contains `loading: false`
  status: 'loaded',
  token: state.token,
})

interface AuthState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  token: string | null
  msg: string
  isSTKExpired: boolean
}

export const initial: AuthState = {
  status: 'idle',
  token: null,
  msg: '',
  isSTKExpired: false,
}

export const sessionReducer = createReducer(initial, {
  [setSTKToken.toString()]: (state, action) => {
    state.token = action.payload
  },
  [loadRequiredData.pending.toString()]: authStartPending,
  [refreshSTK.pending.toString()]: authStartPending,
  [logout.pending.toString()]: authStartPending,
  [login.fulfilled.toString()]: authActionFullfiled,
  [refreshSTK.fulfilled.toString()]: authActionFullfiled,
  [logout.fulfilled.toString()]: authActionFullfiled,
  [login.rejected.toString()]: (state, action) => {
    state.status = 'loaded' // we should display login page
    state.msg = action.payload?.message
  },
  [setSTKExpired.toString()]: (state, action) => {
    state.isSTKExpired = action.payload
  },
  [setReady.toString()]: (state) => {
    state.status = 'loaded'
  },
})

export const authReducer = combineReducers({
  session: sessionReducer,
})
